<template>
  <section class="section personal-cabinet">
    <div class="section__container personal-cabinet__container">
      <h2 class="section__title personal-cabinet__title"
          id="personal-cabinet">Пользователям Ferma доступен личный кабинет с широким функционалом:</h2>
      <div class="personal-cabinet__content">
        <ul class="personal-cabinet__functions">
          <li class="personal-cabinet__functions-item">контроль за состоянием касс и отправкой чеков</li>
          <li class="personal-cabinet__functions-item">гибкая настройка доступов разного уровня</li>
          <li class="personal-cabinet__functions-item">формирование и выгрузка аналитических отчетов</li>
          <li class="personal-cabinet__functions-item">настройки необходимых уведомлений</li>
          <li class="personal-cabinet__functions-item">возможность автоматической отправки отчетов на e-mail</li>
        </ul>
        <p class="personal-cabinet__text">Являясь одновременно производителем облачных онлайн касс и оператором фискальных данных, мы
          обеспечим для вас в едином личном кабинете:</p>
        <ul class="personal-cabinet__services">
          <li class="personal-cabinet__services-item">Регистрацию/перерегистрацию касс в ФНС и оплату сервисов</li>
          <li class="personal-cabinet__services-item">Формирование и выгрузку отчетов:
            <ul class="personal-cabinet__reports">
              <li class="personal-cabinet__reports-item">отчет по сменам</li>
              <li class="personal-cabinet__reports-item">отчет по номенклатуре</li>
              <li class="personal-cabinet__reports-item">отчет «Статистика отправки электронных чеков»</li>
              <li class="personal-cabinet__reports-item">отчет «Сверка»</li>
              <li class="personal-cabinet__reports-item">отчет «Мониторинг ККТ и ФН»</li>
              <li class="personal-cabinet__reports-item">отчет «Архив ФН»</li>
              <li class="personal-cabinet__reports-item">отчет «Маркировка»</li>
            </ul>
          </li>
          <li class="personal-cabinet__services-item">Возможность ручной и пакетной фискализации</li>
        </ul>
        <div class="personal-cabinet__action">
          <a class="button" v-scrollTo="'calc'">
            Подключить Ferma
            <img src="../../assets/images/chevron.svg" alt="">
          </a>
        </div>
        <div class="personal-cabinet__slider">
          <v-carousel height="auto"
                      width="100%"
                      :show-arrows="false"
                      class="personal-cabinet__slider-list">
            <v-carousel-item class="personal-cabinet__slider-item">
              <img src="./assets/pk-monitoring.png" alt="">
            </v-carousel-item>
            <v-carousel-item class="personal-cabinet__slider-item">
              <img src="./assets/pk-sales.png" alt="">
            </v-carousel-item>
          </v-carousel>
        </div>
      </div>
      <div class="personal-cabinet__monitoring"></div>

      <div class="personal-cabinet__sales"></div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PersonalCabinet'
}
</script>

<style src="./component.scss" scoped lang="scss"/>
